import { membershipApi } from "@bw/shared/api";
import type { SubscribeRequest } from "@bw/shared/types/generated";
import { useEphemeralSubscriptionMutation } from "./useEphemeralSubscriptionMutation";

/**
 * Create a real recurring subscription (POST /memberships/subscribe). The body
 * carries facility_id + plan_id + the stripe_payment_method_id (the card saved
 * against the facility's connected account). The Stripe charge happens
 * SERVER-SIDE inside this call — the FE never confirms a charge.
 *
 * On success the caller's `mine` + `visitBalances` arms are invalidated so My
 * Memberships reflects the new subscription (and any minted pass balance) as
 * server truth. Errors surface on `mutation.error` for the purchase page to map
 * (402/SCA decline, 409 already-subscribed, 400 facility not ready) — never a
 * fabricated success.
 */
export function useSubscribe() {
  return useEphemeralSubscriptionMutation(
    (data: SubscribeRequest) => membershipApi.subscribe(data),
    (_variables, response) => response?.subscription_id,
  );
}
